import http from '@services/http'
import {
  ICompanyPick,
  ICompanyPickContent,
  ICompanyPickLike,
  ICompanyPickManagers,
  ICompanyPickNotice,
  ICompanyPicks,
  ICreateCompanyPickFirstReadLog,
  IHomeCompanyPicks,
} from '@protocol/company-pick'

export default {
  fetchHomeCompanyPicks(data: IHomeCompanyPicks.Params): Promise<IHomeCompanyPicks.Schema> {
    return http.get('companyPick/homeCompanyPicks', data || {})
  },
  fetchCompanyPicks(data: ICompanyPicks.Params): Promise<ICompanyPicks.Schema> {
    return http.get('companyPick/companyPicks', data || {})
  },
  fetchCompanyPickMyLikedList(data: ICompanyPicks.Params): Promise<ICompanyPicks.Schema> {
    return http.get('companyPick/companyPickMyLikedList', data || {})
  },
  fetchCompanyPick(data: ICompanyPick.Params): Promise<ICompanyPick.Schema> {
    return http.get('companyPick/companyPick', data || {})
  },
  fetchCompanyPickContent(data: ICompanyPickContent.Params): Promise<ICompanyPickContent.Schema> {
    return http.get('companyPick/companyPickContent', data || {})
  },
  fetchManagers(data: ICompanyPickManagers.Params): Promise<ICompanyPickManagers.Schema> {
    return http.get('companyPick/managers', data || {})
  },
  fetchNotice(data: ICompanyPickNotice.Params): Promise<ICompanyPickNotice.Schema> {
    return http.get('companyPick/notice', data || {})
  },
  toggleCompanyPickLike(data: ICompanyPickLike.Params): Promise<ICompanyPickLike.Schema> {
    return http.post('companyPick/toggleCompanyPickLike', data || {})
  },
  createCompanyPickFirstReadLog(data: ICreateCompanyPickFirstReadLog.Params)
    : Promise<ICreateCompanyPickFirstReadLog.Schema> {
    return http.post('companyPick/createCompanyPickFirstReadLog', data || {})
  },
}


/*

 */

// 123